import cx from 'classnames';
import type { VoidFunctionComponent } from 'react';

import styles from './NoResults.module.less';

type Props = {
  isLoading: boolean;
};

/**
 * Renders a message indicating that no results matched the search.
 */
const CommandPaletteNoResults: VoidFunctionComponent<Props> = ({ isLoading }) => (
  <div className={cx(styles.noResults, { [styles.loadingResults]: isLoading })}>
    {isLoading ? 'Searching...' : 'No results matched your search'}
  </div>
);

export default CommandPaletteNoResults;
